module.exports = __webpack_public_path__ + "img/import-icon.fdc572f6.svg";